'use client';

type PartnerCustomHeadingProps = {
  displayName: string;
};

export function PartnerCustomHeading({
  displayName,
}: PartnerCustomHeadingProps) {
  return (
    <h1 className="hc-typography--heading-four mb-24-32 text-balance leading-tight">
      A licensed insurance agent at{' '}
      <span className="text-secondary-900">{displayName}</span> just became
      available!
    </h1>
  );
}
